// DesktopNav.js - Horizontal desktop navigation
import React from 'react';
import NavLink from './NavLink';
import { getVisibleItems } from '../../config/navigation';

const DesktopNav = ({ isAuthenticated, adminLevel, onLogout }) => {
  const visibleItems = getVisibleItems(isAuthenticated, adminLevel);

  return (
    <nav className="hidden md:flex items-center space-x-1 lg:space-x-2">
      {visibleItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          icon={item.icon}
          label={item.label}
          showIcon={false}
          className="text-[clamp(0.7rem,1.5vw,0.875rem)] px-2 py-1"
        />
      ))}

      {isAuthenticated && (
        <button
          onClick={onLogout}
          className="text-gray-300 hover:text-white hover:bg-gray-700 px-2 py-1 rounded-md text-[clamp(0.7rem,1.5vw,0.875rem)] transition-colors"
        >
          Logout
        </button>
      )}
    </nav>
  );
};

export default DesktopNav;
